import './App.css';
import { useEffect, useState } from 'react';
import ProfilePhoto from './IMAGE/KALAW.jpeg';
import About from './About';
import Resume from './Resume';
import Education from './Education';
import Projects from './Projects';
import Achievements from './Achievements';
import Competitions from './Competitions';
import Leadership from './Leadership';
import Certificates from './Certificates';
import Skills from './Skills';
import Contact from './Contact';
import StickyFeatures from './StickyFeatures';

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');

  const navigateTo = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const renderContent = () => {
    switch (currentPage) {
      case 'about':
        return <About onNavigateHome={() => navigateTo('home')} />;
      case 'resume':
        return <Resume onNavigateHome={() => navigateTo('home')} />;
      case 'education':
        return <Education onNavigateHome={() => navigateTo('home')} />;
      case 'projects':
        return <Projects onNavigateHome={() => navigateTo('home')} />;
      case 'achievements':
        return <Achievements onNavigateHome={() => navigateTo('home')} />;
      case 'competitions':
        return <Competitions onNavigateHome={() => navigateTo('home')} />;
      case 'leadership':
        return <Leadership onNavigateHome={() => navigateTo('home')} />;
      case 'certificates':
        return <Certificates onNavigateHome={() => navigateTo('home')} />;
      case 'skills':
        return <Skills onNavigateHome={() => navigateTo('home')} />;
      case 'contact':
        return <Contact onNavigateHome={() => navigateTo('home')} />;
      case 'home':
      default:
        return (
          <>
            {/* Hero Section / Landing Page */}
            <section className="hero" id="home">
              <div className="hero-content">
                {/* Animated Badge */}
                <div className="badge">
                  <span className="badge-dot"></span>
                  <span className="badge-text">Welcome to my portfolio</span>
                </div>

                {/* Professional Photo with Glow Effect */}
                <div className="photo-container">
                  <div className="photo-frame">
                    <img
                      src={ProfilePhoto}
                      alt="Your Profile"
                      className="profile-photo"
                    />
                    <div className="photo-overlay"></div>
                  </div>
                </div>

                {/* Full Name */}
                <h1 className="name">
                  <span className="name-word">Christian D. Kalaw</span>
                </h1>

                {/* Professional Title */}
                <div className="title-wrapper">
                  <h2 className="title">
                    Computer Engineering Student
                  </h2>
                  <p className="subtitle">Aspiring Software Developer | Tech Enthusiast</p>
                </div>

                {/* Personal Tagline/Summary */}
                <p className="tagline">
                  Designing elegant solutions to complex problems. Passionate about building innovative software that makes a real impact in the world.
                </p>

                {/* Call-to-Action Buttons */}
                <div className="cta-buttons">
                  <button className="btn btn-primary" onClick={() => navigateTo('projects')}>
                    <span className="btn-text">View My Work</span>
                    <span className="btn-arrow">→</span>
                  </button>
                  <button className="btn btn-secondary" onClick={() => navigateTo('contact')}>
                    <span className="btn-text">Get In Touch</span>
                    <span className="btn-icon">💬</span>
                  </button>
                </div>

                {/* Scroll Indicator */}
                <div className="scroll-indicator">
                  <div className="mouse">
                    <div className="wheel"></div>
                  </div>
                  <span>Scroll to explore</span>
                </div>
              </div>
            </section>

            {/* Scrollable Features Section — outside hero */}
            <StickyFeatures />
          </>
        );
    }
  };

  return (
    <div className="App">
      {/* Animated Background only visible on home to prevent overlay issues */}
      {currentPage === 'home' && (
        <div className="animated-bg">
          <div className="gradient-sphere sphere-1"></div>
          <div className="gradient-sphere sphere-2"></div>
          <div className="gradient-sphere sphere-3"></div>
        </div>
      )}

      {/* Navigation Menu */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <div className="logo-section">
            <div className="profile-logo">
              <img src={ProfilePhoto} alt="Profile" className="profile-img" />
            </div>
            <div className="logo-text">
              <div className="logo-name">Christian</div>
              <div className="logo-title">Developer</div>
            </div>
          </div>
          <ul className="nav-menu">
            <li><a href="#home" className="nav-link" onClick={(e) => { e.preventDefault(); navigateTo('home'); }}>Home</a></li>
            <li><a href="#about" className="nav-link" onClick={(e) => { e.preventDefault(); navigateTo('about'); }}>About</a></li>
            <li><a href="#education" className="nav-link" onClick={(e) => { e.preventDefault(); navigateTo('education'); }}>Education</a></li>
            <li><a href="#skills" className="nav-link" onClick={(e) => { e.preventDefault(); navigateTo('skills'); }}>Skills</a></li>
            <li><a href="#projects" className="nav-link" onClick={(e) => { e.preventDefault(); navigateTo('projects'); }}>Projects</a></li>
            <li><a href="#achievements" className="nav-link" onClick={(e) => { e.preventDefault(); navigateTo('achievements'); }}>Achievements</a></li>
            <li><a href="#competitions" className="nav-link" onClick={(e) => { e.preventDefault(); navigateTo('competitions'); }}>Competitions</a></li>
            <li><a href="#leadership" className="nav-link" onClick={(e) => { e.preventDefault(); navigateTo('leadership'); }}>Leadership</a></li>
            <li><a href="#certificates" className="nav-link" onClick={(e) => { e.preventDefault(); navigateTo('certificates'); }}>Certificates</a></li>
            <li><a href="#resume" className="nav-link" onClick={(e) => { e.preventDefault(); navigateTo('resume'); }}>Resume</a></li>
            <li><a href="#contact" className="nav-link" onClick={(e) => { e.preventDefault(); navigateTo('contact'); }}>Contact</a></li>
          </ul>
        </div>
      </nav>

      <div key={currentPage} className="page-transition-wrapper">
        {renderContent()}
      </div>
    </div>
  );
}

export default App;
